import { Controller } from 'react-hook-form';
import { Box, Button, Typography } from '@mui/material';
import { PasswordInput } from '@resolvvi/pink-flow';
import useForm from './useForm';

type Props = {
  backToEmail: () => void,
  afterSubmit: () => void,
  goToRecoverPassword: () => void,
};

const PasswordForm = ({
  backToEmail, afterSubmit, goToRecoverPassword,
}:Props):JSX.Element => {
  const {
    onSubmit,
    errors,
    control,
    loading,
  } = useForm({ afterSubmit });

  return (
    <form onSubmit={onSubmit}>
      <Box marginTop={2}>
        <Typography
          onClick={backToEmail}
          align="center"
          sx={{
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          Acessar outra conta
        </Typography>
      </Box>
      <Box marginTop={2} marginBottom={2}>
        <Controller
          name="password"
          control={control}
          render={({ field }) => (
            <PasswordInput
              label="Digite sua senha"
              value={field.value}
              onChange={field.onChange}
              required
            />
          )}
        />
        <Typography variant="caption" color="error">{errors?.password?.message as string}</Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" flex="1">
        <Button
          variant="outlined"
          color="primary"
          size="large"
          onClick={goToRecoverPassword}
        >
          Esqueceu a senha?
        </Button>
        <Button variant="contained" color="primary" type="submit" disabled={loading}>Próximo</Button>
      </Box>
    </form>
  );
};

export default PasswordForm;
